import { call, select } from "redux-saga/effects";
import getAllItem from "@gc-npm/adabyron.catalogue.get-all-item";
import getItem from "@gc-npm/adabyron.catalogue.get-item";

export function* fetchDevices(offerCategory = "FUSION_AV") {
  const context = yield select((state) => state.main.context);

  return yield call(getAllItem, {
    context: context,
    offerCategory: offerCategory,
  });
}

export function* fetchDeviceData(alias, storage = null, segment = "FUSION_AV") {
  const context = yield select((state) => state.main.context);

  return yield call(getItem, {
    data: {
      segment,
      alias,
      storage,
    },
    context,
  });
}


